
























































import { defineComponent, ref } from '@vue/composition-api';
import { BreadcrumbItem } from '@/components/base/OareBreadcrumbs.vue';

export default defineComponent({
  setup() {
    const breadcrumbs = ref<BreadcrumbItem[]>([
      {
        link: '/',
        text: 'Home',
      },
    ]);

    return {
      breadcrumbs,
    };
  },
});
